import { UseFormReturn } from 'react-hook-form'
import { Form } from './ui/Form'
import { FormValues } from './ui/Form/model'

type BasicInformationStepProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
  disabledChangePhone?: boolean
}

export function BasicInformationStep({
  onSuccess,
  form,
  disabledChangePhone,
}: BasicInformationStepProps) {
  return (
    <Form
      onSuccess={onSuccess}
      form={form}
      disabledChangePhone={disabledChangePhone}
    />
  )
}
